import React, {Component} from 'react';

//controller
import MemberControllerAPI from '../../controllers/API/MemberControllerAPI.js';

//css
import styles from '../../static/css/pageStyleModules/memberListMode.module.scss';

import HeaderLayout from '../layouts/header/HeaderLayout.js';

//component
import MemberGridListComponent from '../components/MemberGridListComponent.js';

export default class MemberListMode extends Component {
    constructor(props) {
        super(props)
        this.state = {
            workMode:'displayMode',
            // workMode:'orderMode',
            members:[],
            membersReserve:[],
        }
    }

    componentWillMount(){
        
        //member情報を取得
        MemberControllerAPI.index()
        .then((result) => {
            this.setState({members:result.data});
        })
        .catch(function(error){
            console.log(error.message);
        });

    }

    changeToInfoMode = (targetId) => {
        //エディットメンバーを更新
        this.props.getEditMemberId(targetId);
        //ワークモード切り替え
        this.props.changeWorkMode('memberInfoMode');        
    }

    changeToAddMode = () => {
        //エディットメンバーを更新
        this.props.getEditMemberId(null);
        //ワークモード切り替え
        this.props.changeWorkMode('memberEditAndAddMode');        
    }

    changeToOrderMode = () => {
        //ワークモード切り替え
        this.setState({workMode:'orderMode'})
        this.setState({membersReserve:JSON.parse(JSON.stringify(this.state.members))})
    }

    cancelOrderMode = () => {
        this.setState({workMode:'displayMode'})
        this.setState({members:JSON.parse(JSON.stringify(this.state.membersReserve))})
    }

    submitNewOrder = () => {
        this.setState({workMode:'displayMode'});
        //member情報を取得
        MemberControllerAPI.order_store(this.state.members)
        .then((result) => {
            this.props.onInfoDisplayCall('facedHeart','hsl(6,77%,62%)','並び替えました');
            // this.setState({members:result.data});
            this.setState({membersReserve:[]})
        })
        .catch(function(error){
            console.log(error.message);
        });

    }

    changeOrder = (sortedMembers) => {
        this.setState({members:sortedMembers})
    }

    render(){

        return (
            <div className={styles['memberListPageArea']}>
              {this.state.workMode === 'displayMode' && 
                <HeaderLayout 
                leftIcon={'sort'}
                onLeftButtonClick={this.changeToOrderMode} 
                rightIcon={'add'}
                onRightButtonClick={this.changeToAddMode} 
                />
              }
              {this.state.workMode === 'orderMode' && 
                <HeaderLayout 
                leftIcon={'cancel'}
                onLeftButtonClick={this.cancelOrderMode} 
                rightIcon={'circle'}
                rightIconColor={'hsl(6,77%,62%)'}
                onRightButtonClick={this.submitNewOrder} 
                />
              }
              <div className={styles['memberListBox']}>
                <MemberGridListComponent 
                currentWorkMode={this.state.workMode}
                members={this.state.members}
                gridButtonClickEvent={(targetId) => this.changeToInfoMode(targetId)}
                onSortChange={(sortedMembers) => this.changeOrder(sortedMembers)}
                />
              </div>
            </div>
        )
    }
}